import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { useState, useRef, useEffect, useMemo } from 'react';
import { useAddNewassetReqMutation } from '../../../../features/assetrequest/assetReqApiSlice';
import { useGetUsersQuery } from '../../../../features/users/usersApiSlice';
import useAuth from '../../../../features/hooks/useAuth';
import { useGetofficesQuery } from '../../../../features/offices/officesApiSlice';
import { useGetStoreOfficesQuery } from '../../../../features/storeoffices/storeofficesApiSlice';
import { HeadingWrap, Span, CommonButton } from '../../../../Styles/CommonStyles';
import { useNavigate } from "react-router-dom";
import nameStringFn from '../../../../data/nameStringFn';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Chip from '@mui/material/Chip';
import UnivMyAssetComp from '../../Myasset/UnivMyAssetComp';
import { use } from 'react';
import FilteredAssetReqFetcher from '../FilteredAssetReqFetcher';

const Container = styled.div`
  margin-left: 10px;
  margin-right: 10px;
`
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`
const SubmitButton = styled(CommonButton)`
  margin-top: 20px;
  margin-bottom: 20px;
  margin-right: 15px;
  background-color: #4caf50;
  
  &:hover {
    background-color: #45a049;
  }
`

// Styled components for the big buttons
const ButtonsContainer = styled.div`
  display: flex;
  justify-content: space-around;
  margin: 30px 0;
  flex-wrap: wrap;
  gap: 20px;
`

const BigButton = styled.button`
  padding: 20px;
  font-size: 18px;
  font-weight: bold;
  min-width: 300px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  background-color: #008080;
  color: white;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
    background-color: #006666;
  }
  
  &:active {
    transform: translateY(1px);
  }
`

const BackButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
`;

const BackButton = styled.div`
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  color: #1976d2;

  &:hover {
    text-decoration: underline;
  }
`;

const SummaryContainer = styled.div`
  margin-top: 30px;
  margin-bottom: 20px;
`;

const SummaryHeader = styled.h3`
  color: #1976d2;
  margin-bottom: 15px;
`;

const StyledTableContainer = styled(TableContainer)`
  margin-bottom: 20px;
`;

const StyledTableHead = styled(TableHead)`
  background-color: #1976d2;
  
  & th {
    color: white;
    font-weight: bold;
  }
`;

const RemarkContainer = styled.div`
  margin-top: 20px;
  margin-bottom: 20px;
  width: 100%;
`;

const SubmitButtonContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-top: 20px;
`;

const StoreSelectionContainer = styled.div`
  margin-bottom: 20px;
  max-width: 400px;
`;

const UserSelectionContainer = styled.div`
  margin-bottom: 20px;
  max-width: 400px;
`;

const ChipContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

const BoAssetReturnReq = () => {
  const [selectedAssets, setSelectedAssets] = useState([]);
  const [content, setContent] = useState('');
  const [field, setField] = useState([]);  
  const [showReturnToStore, setShowReturnToStore] = useState(false);
  const [showTransferToUser, setShowTransferToUser] = useState(false);
  const [remark, setRemark] = useState('');
  const [selectedStore, setSelectedStore] = useState('');
  const [selectedUser, setSelectedUser] = useState(null);
  const editor = useRef(null);
  const navigate = useNavigate();
  const [allData, setAllData] = useState([]);
  const [filters, setFilters] = useState({
    perm_creator_id: [],
    perm_req_store: [],
    perm_curr_status: []
  });

  // Get logged in user data
  const { id, email, designation, designationSuffix, numSuffix, roles } = useAuth();
  let user_current_office = (useSelector((state) => state.office.off));
  let user_current_role_array = roles[user_current_office];

  // Check if user has BO role
  const isBO = user_current_role_array?.includes('Bo');

  useEffect(() => {
    setFilters({
      perm_creator_id: [id],
      perm_curr_status: ["Pending"]
  });
  }, [user_current_office, selectedStore]);

  // Get store offices data
  const { storeoffices } = useGetStoreOfficesQuery('storeoffices', {
    selectFromResult: ({ data }) => ({
      storeoffices: data?.entities
    }),
  });

  // Get user call/single user call
  const { getSingleuser } = useGetUsersQuery('userslist', {
    selectFromResult: ({ data }) => ({
      getSingleuser: data?.entities
    }),
  });

  // Add mutation call
  const [addNewRequest, { isLoading: addNewRequestloading }] = useAddNewassetReqMutation();

  const { offices } = useGetofficesQuery('officelist', {
    selectFromResult: ({ data }) => ({
        offices: data?.entities
    }),
  });


  useEffect(() => {
    if (!selectedAssets || !selectedAssets?.length) return
    setField(prev => {
      const newFields = [...prev]
      selectedAssets.forEach(x => {
        const exists = newFields.some(elm => elm.oem_tag === x.oem_tag);
        if (!exists) {
          newFields.push({
            id:x.id,
            oem_tag: x.oem_tag,
            assetName: x.name,
            spec: x.specification,
            pur_date: x.purchase_date,
            wrty_date: x.warrantyexp_date
          })
        }
      })
      return newFields;
    })
  },[selectedAssets])

  // Generate summary data from selected assets
  const assetSummary = useMemo(() => {
    const summary = {};
    
    if (selectedAssets && selectedAssets.length > 0) {
      selectedAssets.forEach(asset => {
        if (summary[asset.name]) {
          summary[asset.name].count += 1;
          summary[asset.name].assets.push(asset);
        } else {
          summary[asset.name] = {
            count: 1,
            assets: [asset]
          };
        }
      });
    }
    
    return Object.entries(summary).map(([name, data]) => ({
      name,
      count: data.count,
      assets: data.assets
    }));
  }, [selectedAssets]);

  // Find Store Level 1 Approver
  const StoreL1_id = storeoffices ? Object.values(storeoffices)?.find(office => office?.storeoffice === selectedStore)?.roleUsers?.L1ReqApprover_A : "";
  const UnitHead_id = offices ? Object.values(offices)?.find(office => office?.name === user_current_office)?.unitHead : "";

  
  const handleReturnToStore = () => {
    if (allData?.requests?.filter(x => x.req_type === "BO_Store_Return")?.length) return alert('You have a pending BO to Store transfer request. Please wait for it to be processed before creating a new one.');
    setShowReturnToStore(true);
    setShowTransferToUser(false);
    setSelectedStore('');
    setSelectedUser(null);
    setSelectedAssets([]);
  };

  const handleTransferToUser = () => {
    if (allData?.requests?.filter(x => x.req_type === "BO_User_Transfer")?.length) return alert('You have a pending BO to User transfer request. Please wait for it to be processed before creating a new one.');
    setShowTransferToUser(true);
    setShowReturnToStore(false);
    setSelectedStore('');
    setSelectedUser(null);
    setSelectedAssets([]);
  };

  const handleBack = () => {
    setShowReturnToStore(false);
    setShowTransferToUser(false);
    setSelectedAssets([]);
    setSelectedStore('');
    setSelectedUser(null);
    setRemark('');
  };

  const handleRemarkChange = (e) => {
    setRemark(e.target.value);
  };

  const handleStoreChange = (e) => {
    setSelectedStore(e.target.value);
    setSelectedAssets([]);
  };

  const handleUserChange = (newValue) => {
    setSelectedUser(newValue);
    setSelectedAssets([]);
  };

  const handleAssetSelect = (asset) => {
    const assetIndex = selectedAssets.findIndex(a => a._id === asset._id);
    if (assetIndex === -1) {
      setSelectedAssets([...selectedAssets, asset]);
    } else {
      const newSelectedAssets = [...selectedAssets];
      newSelectedAssets.splice(assetIndex, 1);
      setSelectedAssets(newSelectedAssets);
    }
  };

  //create a unique Id
  const uniqueReqID = () => {
    const dateString = Date.now().toString(36);
    const emailofuser = getSingleuser && getSingleuser[id]?.email?.slice(0, -8)
    const uid = `${emailofuser}-${dateString}`
    return uid;
  };
  let uniqueReqId = uniqueReqID()
  
  const handleSubmitToStore = async () => {
    if (allData?.requests?.filter(x => (x.req_store === selectedStore && x.req_type === "BO_Store_Return"))?.length) return alert('You have a pending request. Please wait for it to be processed before submitting a new one.')
    const allRequestedAssetIds = allData?.requests.flatMap(doc =>
      doc.assets_requested?.flatMap(a => a.data.map(d => d.id)) || []
    );
    const matchedAssets = selectedAssets.filter(sel =>
      allRequestedAssetIds.includes(sel.id)
    );
    if (matchedAssets.length > 0) {
      const message = matchedAssets
        .map(asset => `• ${asset.name} (${asset.oem_tag})`)
        .join("\n");

      return alert(`Request for following Assets are already submitted and pending :\n${message}`);
    }
    if (selectedAssets.length === 0) {
      alert("Please select at least one asset to return");
      return;
    }

    if (!remark.trim()) {
      alert("Please provide a remark for your return request");
      return;
    }

    if (!selectedStore) {
      alert("Please select a store to return assets to");
      return;
    }

    // Create request data for returning assets to store
    let boReturnData = {
      uniqueReqId: uniqueReqId,
      req_type: "BO_Store_Return",
      req_creator_id: id,
      req_creator_details: `${nameStringFn(getSingleuser?.[id])}-${user_current_office}-${designation[user_current_office]}`,
      req_store: selectedStore,
      assets_requested: [{ time_stamp: new Date(), actionNo:1, data:field }],
      bo_partial_issue: false,
      bo_assets_issue: [],
      store_partial_issue: false,
      store_assets_issue: [],
      curr_status: 'Pending',
      created_at: new Date(),
      curr_sent_by: id,
      curr_sent_to: UnitHead_id,
      curr_sent_to_string: `${nameStringFn(getSingleuser?.[UnitHead_id])}-${user_current_office}-${getSingleuser?.[UnitHead_id]?.designation?.[user_current_office] || 'Unknown'}`,
      curr_sent_to_tag: 'bo_store_return_created',
      flow_users: [id],
      req_data: [{
        sent_to_tag: "bo_store_return_created",
        Text: remark,
        sent_by: { 
          id: id, 
          name: getSingleuser?.[id]?.name, 
          office: user_current_office, 
          designation: designation[user_current_office], 
          designationSuffix: designationSuffix[user_current_office], 
          numSuffix: numSuffix[user_current_office] 
        },
        sent_to: {
          id: UnitHead_id,
          name: getSingleuser?.[UnitHead_id]?.name,
          office: user_current_office,
          designation: getSingleuser?.[UnitHead_id]?.designation?.[user_current_office] || 'Unknown'
        },
        action: 'New BO Asset Return Request to Store Created',
        time_stamp: new Date()
      }],
      opened: false
    };

    try {
      await addNewRequest(boReturnData);
      setContent('');
      setSelectedAssets([]);
      setSelectedStore('');
      setRemark('');
      navigate('/management/assets/myrequests');
      return alert('Return Request Forwarded to Unit Head');
    } catch (err) {
      return alert(`Error:${err}`);
    }
  };

  const handleSubmitToUser = async () => {
    const allRequestedAssetIds = allData?.requests.flatMap(doc =>
      doc.assets_requested?.flatMap(a => a.data.map(d => d.id)) || []
    );
    const matchedAssets = selectedAssets.filter(sel =>
      allRequestedAssetIds.includes(sel.id)
    );
    if (matchedAssets.length > 0) {
      const message = matchedAssets
        .map(asset => `• ${asset.name} (${asset.oem_tag})`)
        .join("\n");

      return alert(`Request for following Assets are already in transition :\n${message}`);
    }
    if (selectedAssets.length === 0) {
      alert("Please select at least one asset to transfer");
      return;
    }

    if (!remark.trim()) {
      alert("Please provide a remark for your transfer request");
      return;
    }

    if (!selectedUser) {
      alert("Please select a valid user to transfer assets to");
      return;
    }

    // Create request data for transferring assets to another user via Unit Head approval
    let boTransferData = {
      uniqueReqId: uniqueReqId,
      req_type: "BO_User_Transfer",
      req_creator_id: id,
      req_creator_details: `${nameStringFn(getSingleuser?.[id])}-${user_current_office}-${designation[user_current_office]}`,
      req_store: "Not Applicable",
      assets_requested: [{ time_stamp: new Date(), actionNo:1, data:field }],
      bo_partial_issue: false,
      bo_assets_issue: [],
      store_partial_issue: false,
      store_assets_issue: [],
      curr_status: 'Pending',
      created_at: new Date(),
      curr_sent_by: id,
      curr_sent_to: UnitHead_id,
      curr_sent_to_string: `${nameStringFn(getSingleuser?.[UnitHead_id])}-${user_current_office}-${getSingleuser?.[UnitHead_id]?.designation?.[user_current_office] || 'Unknown'}`,
      curr_sent_to_tag: 'bo_user_transfer_unithead_approval',
      flow_users: [id],
      final_transfer_user: {
        id: selectedUser._id,
        name: selectedUser.name || {},
        office: user_current_office,
        designation: selectedUser?.designation?.[user_current_office] || 'Unknown'
      },
      req_data: [{
        sent_to_tag: "bo_user_transfer_unithead_approval",
        Text: remark,
        sent_by: { 
          id: id, 
          name: getSingleuser?.[id]?.name, 
          office: user_current_office, 
          designation: designation[user_current_office], 
          designationSuffix: designationSuffix[user_current_office], 
          numSuffix: numSuffix[user_current_office] 
        },
        sent_to: {
          id: UnitHead_id,
          name: getSingleuser?.[UnitHead_id]?.name,
          office: user_current_office,
          designation: getSingleuser?.[UnitHead_id]?.designation?.[user_current_office] || 'Unknown'
        },
        action: 'New BO Asset Transfer Request to User Created - Sent to Unit Head for Approval',
        time_stamp: new Date()
      }],
      opened: false
    };

    try {
      await addNewRequest(boTransferData);
      setContent('');
      setSelectedAssets([]);
      setSelectedUser(null);
      setRemark('');
      navigate('/management/assets/myrequests');
      return alert('Transfer Request Forwarded to Unit Head for Approval');
    } catch (err) {
      return alert(`Error:${err}`);
    }
  };

  // Redirect if not BO
  useEffect(() => {
    if (!isBO) {
      navigate('/management/assets/myrequests');
      alert('You must be a Branch Officer to access this page');
    }
  }, [isBO, navigate]); 

  if (!isBO) {
    return null;
  }

  return (
    <Container>
      <FilteredAssetReqFetcher filters={filters} onDataFetched={setAllData}/>

      {!showReturnToStore && !showTransferToUser && (
        <HeadingWrap>
          <Span>Branch Officer Asset Return Request</Span>
        </HeadingWrap>
      )}
      <Wrapper>
        {!showReturnToStore && !showTransferToUser ? (
          <ButtonsContainer>
            <BigButton onClick={handleReturnToStore}>
              Return Assets to Store
            </BigButton>
            <BigButton onClick={handleTransferToUser}>
              Transfer Assets to User
            </BigButton>
          </ButtonsContainer>
        ) : (
          <>
            <BackButtonWrapper>
              <BackButton onClick={handleBack}>
                <ArrowLeftIcon /> Back to Options
              </BackButton>
            </BackButtonWrapper>
            
            {/* Return to Store Section */}
            {showReturnToStore && (
              <>
                <HeadingWrap>
                  <Span>Return BO Assets to Store</Span>
                </HeadingWrap>
                
                <StoreSelectionContainer>
                  <FormControl fullWidth>
                    <InputLabel id="store-select-label">Select Store</InputLabel>
                    <Select
                      labelId="store-select-label"
                      id="store-select"
                      value={selectedStore}
                      label="Select Store"
                      onChange={handleStoreChange}
                    >
                      {storeoffices && Object.values(storeoffices).map((store) => (
                        <MenuItem key={store.storeoffice} value={store.storeoffice}>
                          {store.storeoffice}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </StoreSelectionContainer>
                
                {selectedStore && (
                <>
                  <h3 style={{ textAlign: 'left', marginTop: '20px', marginBottom: '15px', color: '#1976d2' }}>
                    Select Assets for Returning to Store
                  </h3>

                  <UnivMyAssetComp 
                      columnFilter={["OEM/ORG Tag", "OEM/Brand", "Model", "Store", "Detail"]}
                      checkbox={true}
                      selectedOptions={selectedAssets}
                      setSelectedOptions={setSelectedAssets}
                      selectAll={true}
                      filterProps={{
                        perm_alloc_user:[id],
                        perm_alloc_ofc:[user_current_office],
                        perm_cur_loc:["office"],
                        perm_cur_store:[selectedStore]
                      }}
                  />

                  {selectedAssets.length > 0 && (
                    <SummaryContainer>
                      <SummaryHeader>Selected Assets Summary</SummaryHeader>
                      <StyledTableContainer component={Paper}>
                        <Table aria-label="selected assets summary table">
                          <StyledTableHead>
                            <TableRow>
                              <TableCell>Asset Type</TableCell>
                              <TableCell align="center">Quantity</TableCell>
                              <TableCell>Asset Tags</TableCell>
                            </TableRow>
                          </StyledTableHead>
                          <TableBody>
                            {assetSummary.map((item, index) => (
                              <TableRow key={index}>
                                <TableCell>{item.name}</TableCell>
                                <TableCell align="center">{item.count}</TableCell>
                                <TableCell>
                                  <ChipContainer>
                                    {item.assets.map((asset, i) => (
                                      <Chip
                                        key={i}
                                        label={asset.oem_tag + (asset.org_tag ? `/${asset.org_tag}` : '')}
                                        color="primary"
                                        variant="outlined"
                                        size="small"
                                      />
                                    ))}
                                  </ChipContainer>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </StyledTableContainer>
                      
                      <RemarkContainer>
                        <TextField
                          label="Remarks for Asset Return"
                          placeholder="Please provide details about why you are returning these assets"
                          multiline
                          rows={4}
                          value={remark}
                          onChange={handleRemarkChange}
                          fullWidth
                          required
                        />
                      </RemarkContainer>

                      <SubmitButtonContainer>
                        <SubmitButton onClick={handleSubmitToStore}>
                          Submit Return Request to Store Through Unit Head
                        </SubmitButton>
                      </SubmitButtonContainer>
                    </SummaryContainer>
                  )}
                </>
                )}
              </>
            )}
            
            {/* Transfer to User Section */}
            {showTransferToUser && (
              <>
                <HeadingWrap>
                  <Span>Handover BO Assets to User</Span>
                </HeadingWrap>
                
                <UserSelectionContainer>
                <Autocomplete
                  id="user-select"
                  options={Object.values(getSingleuser || {}).filter(
                    user => user?.office?.mainCharge === user_current_office && user._id !== id
                  )}
                  getOptionLabel={(option) =>
                    `${option.name?.firstName || ''} ${option.name?.lastName || ''} (${option.email || ''})`
                  }
                  value={selectedUser}
                  onChange={(event, newValue) => handleUserChange(newValue)}
                  isOptionEqualToValue={(option, value) => option._id === value._id}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select User"
                      placeholder="Search for users in your office"
                    />
                  )}
                />
                </UserSelectionContainer>
               
                {selectedUser && (
                <>
                  <h3 style={{ textAlign: 'left', marginTop: '20px', marginBottom: '15px', color: '#1976d2' }}>
                    Select Assets for Transferring to User
                  </h3>

                  <UnivMyAssetComp 
                      columnFilter={["OEM/ORG Tag", "OEM/Brand", "Model", "Store", "Detail"]}
                      selectedOptions={selectedAssets}
                      setSelectedOptions={setSelectedAssets}
                      selectAll={true}
                      filterProps={{
                        perm_alloc_user:[id],
                        perm_alloc_ofc:[user_current_office],
                      }}
                  />
                
                  {selectedAssets.length > 0 && (
                    <SummaryContainer>
                      <SummaryHeader>Selected Assets Summary</SummaryHeader>
                      <StyledTableContainer component={Paper}>
                        <Table aria-label="selected assets summary table">
                          <StyledTableHead>
                            <TableRow>
                              <TableCell>Asset Type</TableCell>
                              <TableCell align="center">Quantity</TableCell>
                              <TableCell>Asset Tags</TableCell>
                            </TableRow>
                          </StyledTableHead>
                          <TableBody>
                            {assetSummary.map((item, index) => (
                              <TableRow key={index}>
                                <TableCell>{item.name}</TableCell>
                                <TableCell align="center">{item.count}</TableCell>
                                <TableCell>
                                  <ChipContainer>
                                    {item.assets.map((asset, i) => (
                                      <Chip
                                        key={i}
                                        label={asset.oem_tag + (asset.org_tag ? `/${asset.org_tag}` : '')}
                                        color="primary"
                                        variant="outlined"
                                        size="small"
                                      />
                                    ))}
                                  </ChipContainer>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </StyledTableContainer>
                      
                      <RemarkContainer>
                        <TextField
                          label="Remarks for Asset Transfer"
                          placeholder="Please provide details about why you are transferring these assets to this user"
                          multiline
                          rows={4}
                          value={remark}
                          onChange={handleRemarkChange}
                          fullWidth
                          required
                        />
                      </RemarkContainer>
                      
                      <SubmitButtonContainer>
                        <SubmitButton onClick={handleSubmitToUser}>
                          Submit Transfer Request to User
                        </SubmitButton>
                      </SubmitButtonContainer>
                    </SummaryContainer>
                  )}
                </>
                )}
              </>
            )}
          </>
        )}
      </Wrapper>
    </Container>
  );
};

export default BoAssetReturnReq;